// import axios from "axios";

const initialState = {
  fetched: false,
  allLessons: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "FETCHED_LESSON":
      return {
        ...state,
        fetched: true,
        allLessons: state.allLessons.concat(action.data),
      };
    case "ADDED_LESSON":
      return {
        ...state,
        allLessons: [action.data].concat(state.allLessons),
      };

    case "UPDATED_LESSON":
      return {
        ...state,
        allLessons: state.allLessons.map((lesson) =>
          lesson.id === action.data.id ? action.data : lesson
        ),
      };
    case "DELETED_LESSON":
      return {
        ...state,
        allLessons: state.allLessons.filter((lesson) => lesson.id !== action.lessonId),
      };
    case "LOGOUT":
      return {
        ...state,
        fetched: false,
        allLessons: [],
      };
    case "EMPTY_LESSON":
      return {
        ...state,
        fetched: false,
        allLessons: [],
      };
    default:
      return state;
  }
};
